import gql from "graphql-tag";

export const UPDATE_PHONE_NUMBER = gql`
  mutation UpdatePhoneNumber($newPhoneNumber: String!) {
    updatePhoneNumber(newPhoneNumber: $newPhoneNumber)
  }
`;
